import { render, staticRenderFns } from "./vendors-summary-list.vue?vue&type=template&id=71d96cfd&scoped=true&"
import script from "./vendors-summary-list.vue?vue&type=script&lang=js&"
export * from "./vendors-summary-list.vue?vue&type=script&lang=js&"
import style0 from "./vendors-summary-list.vue?vue&type=style&index=0&id=71d96cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d96cfd",
  null
  
)

export default component.exports